/**
 * @module app.docs
 * @preferred
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule } from 'app/shared/config/modules';
import { IAppRouteConfig } from 'app/shared/config/router-types';
import { buildJsonPropertyPath } from 'app/shared/lib/utilities';

@autoinject
export class DocsModule extends AppModule {

    public readonly code = 'docs';

    constructor(private readonly logger: AppLogger) {
        super();
        logger.source = this;
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return [] //['docs'];
    }

    public getRoutes(): IAppRouteConfig[] {
        return [
            { route: 'docs', name: 'home', moduleId: PLATFORM.moduleName('app/docs/pages/home'), settings: { bypassAuthentication: true } },
            { route: 'docs/*doc', name: 'doc', moduleId: PLATFORM.moduleName('app/docs/pages/doc'), settings: { bypassAuthentication: true } }
        ];
    }
}
